//@flow
import * as React from 'react';
import { XAxis as RechartXAxis } from 'recharts';

import CustomizedAxisTick from './CustomizedAxisTick';
import { dashboardColors } from 'common/enums/ColorEnum';

type Options = {
    domainAxis: Object,
    data: Object,
    startIndex: ?number,
    endIndex: ?number,
    chartType: string,
    chartWidth: number,
    relativeHeight: number,
    relativeWidth: number,
    theme: Object
};

export const createXAxis = ({
    domainAxis,
    data,
    startIndex,
    endIndex,
    chartType,
    chartWidth,
    relativeHeight,
    relativeWidth,
    theme
}: Options) => {
    const totalTicks =
        typeof startIndex === 'number' && typeof endIndex === 'number'
            ? endIndex - startIndex + 1
            : data.values.length;
    const rotateTicks =
        domainAxis.tickType === 'STRING' && chartWidth / totalTicks < 67
            ? true
            : false;
    const useEllipsis = domainAxis.tickType === 'STRING';
    const doubleHeight = relativeHeight >= 1.5;
    const ROTATED_HEIGHT = doubleHeight ? 66 : 50; // this means width of ticks ~ 70 (see CustomizedAxisTick)
    const DEFAULT_HEIGHT = 30;

    return (
        <RechartXAxis
            padding={
                chartType === 'LINE' && totalTicks <= 2
                    ? { right: 20, left: 20 }
                    : {}
            }
            stroke={dashboardColors.offWhite.code}
            dataKey={domainAxis.key}
            tickSize={4}
            tick={getTickCustomizer({
                totalTicks,
                rotateTicks,
                useEllipsis,
                chartWidth,
                relativeHeight,
                relativeWidth,
                theme
            })}
            height={
                useEllipsis && rotateTicks ? ROTATED_HEIGHT : DEFAULT_HEIGHT
            } // needed to create space
            interval={useEllipsis ? 0 : 'preserveEnd'}
        />
    );
};

const renderCustomizedTick = (
    {
        totalTicks,
        rotateTicks,
        useEllipsis,
        chartWidth,
        relativeHeight,
        relativeWidth,
        theme
    },
    props
) => {
    return (
        <CustomizedAxisTick
            totalTicks={totalTicks}
            rotateTicks={rotateTicks}
            useEllipsis={useEllipsis}
            chartWidth={chartWidth}
            relativeHeight={relativeHeight}
            relativeWidth={relativeWidth}
            theme={theme}
            xAxis
            {...props}
        />
    );
};

const getTickCustomizer = tickOptions => {
    return renderCustomizedTick.bind(this, tickOptions);
};
